import React from "react";
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import Colors from "../utils/colors";
import "./components/CardGrid.css";
import HomeProducts from "./components/prods";
import { BsStars } from "react-icons/bs";
import HomeInd from "./components/ind";


const prods = require("./d/prod-l.json");

function Home(){
return (
<>
  <Header />
  <div className="main">
    <div className="">
    <div className="flex-center" style={{flexDirection:"column", justifyContent:'flex-start', minHeight:"100vh", padding:"0em 2em ", textAlign:"center", backgroundColor:"#f6f7f8" }}>
      <div className="fw-bolder col-md-11 hero-title" style={{ marginTop:"5rem", fontWeight:800 }}>
        Streamline your financial operations with MonyTrack Business
      </div>
      <div className="col-md-8 align-left-on-mobile" style={{fontSize:"1.4rem", color:Colors.black1, marginTop:"20px"}}>
        Setup your team to win. Save time and money, eliminate fraud, and take control of your financial operations — all on one secure platform.
      </div>

      <div className="col-md-8" style={{marginTop:"2rem"}}>
        <div className="flex-center"  >
          <div style={{margin:"5px 8px 5px 0px", }}>
            <Link to="mailto:sales@monytrack.com?subject=Schedule a demo for MonyTrack Business&body=Hello MonyTrack Team,%0D%0A %0D%0A..." >
                <Button
                  style={{backgroundColor:Colors.light, color:Colors.black, fontWeight:'normal !important',  fontSize:"1.2rem", borderRadius:"5px", borderColor:Colors.gray2, padding:".8rem 1.2rem", }}
                  className="" >Schedule a free demo</Button>
            </Link>
          </div>
          <div style={{margin:"5px 0px 5px 8px"}}>
            <a target="_blank" href="https://business.monytrack.com/auth/register" style={{position:'relative', zIndex:0}}>
                <Button autoFocus
                        style={{ backgroundColor:Colors.primary, color:Colors.light, fontWeight:'normal',  fontSize:"1.2rem", borderRadius:"5px", borderColor:Colors.primary, padding:".8rem 1.2rem"}}
                        className="" >Try it for free</Button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="flex-center" style={{marginTop:"-8rem", width:"100%", background:'linear-gradient(to bottom, #f6f7f8, #fff)'}}>
      <div className="col-md-8">
        <div style={{width:"100%", background:'linear-gradient(to bottom, #d5aa6b, #fff)', padding:"1rem", borderRadius:"10px", border:"0px solid "+Colors.primary1}}>
          <iframe width="100%" style={{height:"28rem"}}
          src="https://www.youtube.com/embed/iZSRNl9WHBs">
          </iframe>
        </div>
      </div>
    </div>
    </div>


    <div className="flex-center" style={{padding:"4rem 2rem"}}>
      <div className="col-lg-10">
        <div className="flex-center" style={{flexDirection:'column'}}>
          <div className="flex-row" style={{margin:"2rem 0px"}}>
            <BsStars color={Colors.primary3} />
            <div style={{fontSize:"1.2rem", color:Colors.primary3, marginLeft:"5px" }}>Features</div>
          </div>
          <div className="section-title" style={{marginBottom:"12px"}}>Simple, effective tools for your business.</div>
          <div className="col-md-8 align-left-on-mobile" style={{fontSize:"1.3rem", color:Colors.black1, textAlign:"center"}}>Everything you need to simplify your financial operations - all on one platform. Save money and time, and get more done with these tools.</div>
        </div>
        <br/> <br/>
        <div className="row no-margin" style={{flexWrap:"wrap"}}>
          {
            prods?.map((p, i)=>
              <div className="col-md-6 no-padding-on-mobile"  style={{padding:"0rem 1.0rem"}}>
                <HomeProducts d={p} />
              </div>
            )
          }          
        </div>
      </div>
    </div>
    <HomeInd />
  </div>
  <Footer />
</>
);
};

export default Home;
